import React from "react";

const FavoriteIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="clipPath5024887448">
          <path
            d="M0 0L30 0L30 30L0 30L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath5024887448)">
        <path
          d="M0.0304999 -0.999999C-0.521779 -1.00091 -0.970237 -0.553928 -0.971147 -0.00164844L-0.999999 17.4983C-1.00091 18.0506 -0.553928 18.4991 -0.00164859 18.5C0.550631 18.5009 0.999088 18.0539 0.999999 17.5016L1.02885 0.00164865C1.02976 -0.550631 0.582779 -0.999088 0.0304999 -0.999999Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 15.015 6.25002)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M-1 0C-1 0.55228 -0.55228 1 0 1L17.5 1C18.0523 1 18.5 0.55228 18.5 0C18.5 -0.55228 18.0523 -1 17.5 -1L0 -1C-0.55228 -1 -1 -0.55228 -1 0Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 6.2498 15)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default FavoriteIcon;
